/* Copyright (C) Envialo México SA de CV - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by:
 * @author América Mendoza  <amendoza@nodeport.co>,
 * @author Darién Miranda <dmiranda@nodeport.co>,
 * @author Oscar Peña <opena@nodeport.co>,
 * May 2023
 */

import React from 'react';
import {withRouter} from "react-router";
import Row from "react-bootstrap/cjs/Row";
import Container from "react-bootstrap/Container";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Card from  "react-bootstrap/Card";
import { register } from 'swiper/element/bundle';
import Swal from "sweetalert2";
import API from "../../lib/api/NbioApi";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import Offcanvas from "react-bootstrap/Offcanvas";
import {toast} from "sonner";

 //style
import "../../scss/components/carousel.scss";

//components
import DragZone from "../ui/Dropzone";


let Reorder = require('react-reorder');
register();

class Carousel extends React.Component {
    constructor(p) {
        super(p);
        this.state = {
            page: {
                isStaticPage:false,
                title:'',
                subtitle:'',
                description:'',
                labelCTA:'',
                goTo: '',
                image: '',
                imageMobile: '',
            },
            carousel:{pages:[]},
            showModal:false,
            pages:[],
            showAlert:false,
            alertVariant:'primary',
            alertMessage:''
        }


        this.getCarousel                = this.getCarousel.bind(this);
        this.onClickSaveCarouselItem    = this.onClickSaveCarouselItem.bind(this);
        this.validateCarouselItem       = this.validateCarouselItem.bind(this);
        this.onImageDropped             = this.onImageDropped.bind(this);
        this.onImage2Dropped            = this.onImage2Dropped.bind(this);
        this.onChange                   = this.onChange.bind(this);
        this.confirmDelete              = this.confirmDelete.bind(this);
        this.swiperElRef = React.createRef();
        this.swiper  = null;
        this.progress = null;
    }

    componentDidMount() {
        this.getCarousel();

        this.swiperElRef.current.addEventListener('progress', (e) => {
            this.swiper = e.detail;
            this.progress = e.detail;
        });

        this.swiperElRef.current.addEventListener('slidechange', (e) => {
        });
    }

    getCarousel = () => {
        API.store.getCarousel().then((res) => {
            // debugger;
            const carousel = res.data.carousel
            this.setState({carousel: carousel, pages: carousel.pages});
        }).catch((ex) => {
            console.log(ex);
        })
    }

    onChange = (e) => {
        this.setState(prevState => {
            let page = Object.assign({}, prevState.page);
            if(e.target.id === "isStaticPage"){
                page[e.target.id] =e.target.checked;
            }else{
                page[e.target.id] = e.target.value;
            }
            return {page};
        });
    }

    confirmDelete = (item,index) => {
        Swal.fire({
            icon: 'warning',
            title: '¿Estás seguro de borrar la página?',
            cancelButtonText: 'No',
            confirmButtonColor: '#f32735',
            confirmButtonText: 'Si, borrar',
            showCancelButton: true,
            reverseButtons: true,
            heightAuto:false
        }).then((res) => {
            if (res.isConfirmed) {
                this.onDelete(item,index);
            }
        })
    }

    onClickSaveCarouselItem = () => {
        const toastAddingCarouselItem = toast.loading('Agregando la página...', { duration: 1500 });
        this.setState({isUploading:true});
        const isCarouselValid = this.validateCarouselItem();
        if (isCarouselValid) {
            const page = {page:this.state.page};
            page.goTo = ((page.goTo) || '').trim();
            API.admin.createCarouselItem(page).then((res) => {
                //on add new carousel item close modal and reset values

                toast.success('Página agregada', {id:toastAddingCarouselItem});
                this.setState({showModal: false,isUploading:false});
                this.getCarousel();
                this.resetNewCarouselItem();
            }).catch((ex) => {
                this.setState({isUploading:false});
                let errorMsg = 'Hubo un error al crear la página';
                try {
                    errorMsg = ex.response.data.error_es;
                } catch (ex) {

                }
                toast.error(errorMsg,{id:toastAddingCarouselItem});
                this.getCarousel();
            });
        }else{
            this.setState({isUploading:false});
        }
    }

    validateCarouselItem = () => {
        const page    = this.state.page;
        const image = page.image;
        const imageMobile = page.imageMobile;
        if (image.trim() === '' || image === null) {
            toast.error('Agrega una imagen para móviles.');
            return false
        }
        if (imageMobile.trim() === '' || imageMobile === null) {
            toast.error('Agrega una imagen para web.');

            return false
        }
        return true
    }

    onImageDropped(image) {
        const page = {...this.state.page};
        page.image = image;
        this.setState({page: page})
    }

    onImage2Dropped(imageMobile) {
        const page = {...this.state.page};
        page.imageMobile = imageMobile;
        this.setState({page: page})
    }

    resetNewCarouselItem = () => {
        this.setState({page:{}})
    }

    onReorder (event, previousIndex, nextIndex, fromId, toId) {
        const toastUpdatingCarousel = toast.loading('Actualizando el carrusel...', { duration: 1500 });

        this.setState({
            pages: this.reorder(this.state.pages, previousIndex, nextIndex)
        }, () => {
            const pages = {pages:this.state.pages};
            API.admin.updateCarouselPages(pages).then(res => {
                this.getCarousel();
                toast.success('Carrusel actualizado', { id: toastUpdatingCarousel })
            }).catch(ex => {
                console.log(ex);
                toast.error('Hubo un error actualizando el carrusel', { id: toastUpdatingCarousel })
            })
        });
    }

    reorder(pages,p,n) {
        let newPages = [...pages];
        newPages[p] = pages[n];
        newPages[n] = pages[p];
        return newPages;
    }

    onDelete = (item,index) =>{
        const toastDeletingCarouselItem = toast.loading('Actualizando el carrusel...', { duration: 1500 });
        let newPages = [...this.state.pages];
        newPages = newPages.filter((p,i) => i !== index);

        API.admin.updateCarouselPages({pages:newPages}).then(res => {
            this.getCarousel();
            toast.success('Carrusel actualizado', { id: toastDeletingCarouselItem })
        }).catch(ex => {
            toast.error('Hubo un error actualizando el carrusel', { id: toastDeletingCarouselItem })
        })
    }

    render() {
        const page        = this.state.page;
        const image       = page.image ? page.image : null;
        const imageMobile = page.imageMobile ? page.imageMobile : null;
        const pages       = this.state.pages ? this.state.pages : [];

        return (
            <Container fluid className={'h-100'} style={{overflowY:'auto'}}>
                <Row>
                    <Col className='py-3 d-flex align-items-center justify-content-between'>
                        <h5 className={'text-capitalize mr-auto'}>Carrusel</h5>
                        <Button className={'ml-auto'} size={"sm"}
                                onClick={() => this.setState({showModal:true})}>
                            Agregar Página
                        </Button>
                    </Col>
                </Row>
                {/*Left Column*/}
                <Row>
                    <Col sm={6} md={8} className={'pt-3'} >
                        <Card.Title className={'text-primary'}>Páginas del carrusel</Card.Title>
                        <Card.Subtitle className={'text-muted mb-3'}>
                            Arrastra las imágenes para cambiar el orden de aparición en el carrusel
                        </Card.Subtitle>
                        <Row>
                            <Col className='pt-3 overflow-hidden' sm={12}>
                                <Reorder
                                    reorderId={'carousel-page-list'}
                                    lock="horizontal" // Lock the dragging direction (optional): vertical, horizontal (do not use with groups)
                                    holdTime={80} // Default hold time before dragging begins (mouse & touch) (optional), defaults to 0
                                    touchHoldTime={80} // Hold time before dragging begins on touch devices (optional), defaults to holdTime
                                    mouseHoldTime={80} // Hold time before dragging begins with mouse (optional), defaults to holdTime
                                    onReorder={this.onReorder.bind(this)} // Callback when an item is dropped (you will need this to update your state)
                                    disableContextMenus={true} // Disable context menus when holding on touch devices (optional), defaults to true
                                >
                                    {
                                        this.state.pages.map((page,index) => (
                                            <Card key={page._id}  className={'reorder-card prevent-select'}>
                                                <Card.Header className={'d-flex justify-content-between align-items-center prevent-select'}
                                                             onClick={(ev) => {
                                                                 ev.stopPropagation();
                                                             }}>
                                                    <span>
                                                        Página {index+1}
                                                        { page.isStaticPage ? ` / estática` : ''}
                                                    </span>
                                                    <Button className={'ml-auto'} size={"sm"}
                                                            variant={'outline-danger'}
                                                            onClick={() => this.confirmDelete(page,index)}>
                                                        <FontAwesomeIcon icon={"trash"}/>
                                                    </Button>
                                                </Card.Header>
                                                <div className={'card-content'}>
                                                    <img src={page.imageUrl} draggable={false}/>
                                                    <div className={'card-content-column'}>
                                                        <div className={'card-content-labels'}>
                                                            <span style={{width:'121px'}} className={'text-muted'}>Título: </span>
                                                            <span className={'ml-1'}>
                                                                {page.title ? page.title : 'Sin título'}
                                                            </span>
                                                        </div>
                                                        <div className={'card-content-labels'}>
                                                            <span style={{width:'121px'}} className={'text-muted'}>Subtítulo: </span>
                                                            <span className={'ml-1'}>
                                                                {page.subtitle ? page.subtitle : 'Sin subtítulo'}
                                                            </span>
                                                        </div>
                                                        <div className={'card-content-labels'}>
                                                            <span style={{width:'121px'}} className={'text-muted'}>Descripción: </span>
                                                            <span className={'ml-1'}>
                                                                {page.description ? page.description : 'Sin descripción'}
                                                            </span>
                                                        </div>
                                                        <div className={'card-content-labels'}>
                                                            <span style={{width:'121px'}} className={'text-muted'}>Enlace del CTA: </span>
                                                            <span className={'ml-1'}>
                                                                {page.goTo ? page.goTo : 'Sin enlace'}
                                                            </span>
                                                        </div>
                                                        <div className={'card-content-labels'}>
                                                            <span style={{width:'121px'}} className={'text-muted'}>Etiqueta del CTA: </span>
                                                            <span className={'ml-1'}>
                                                                {page.labelCTA ? page.labelCTA : 'Sin etiqueta'}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </Card>
                                        ))
                                        /*
                                        Note this example is an ImmutableJS List so we must convert it to an array.
                                        I've left this up to you to covert to an array, as react-reorder updates a lot,
                                        and if I called this internally it could get rather slow,
                                        whereas you have greater control over your component updates.
                                        */
                                    }
                                </Reorder>
                            </Col>
                        </Row>
                    </Col>

                    {/*Right Column*/}
                    <Col className={'pt-3'} sm={6} md={4}>
                        <Card.Title className={'text-primary'}>Vista previa</Card.Title>
                        <Card.Subtitle className={'text-muted mb-3'}><br/></Card.Subtitle>
                        <Row>
                            <Col className='d-flex pt-3 overflow-hidden' sm={12}>
                                <div className={"swiper-wrapper"}>
                                    <swiper-container
                                        ref={this.swiperElRef}
                                        slides-per-view="1"
                                        navigation="true"
                                        pagination="true"
                                        loop="true"
                                        effect={"fade"}
                                        autoplay={"true"}
                                    >
                                        {pages.map(page => {
                                            return(
                                                <swiper-slide key={page._id} >
                                                    <img src={page.imageUrl} className={"carousel-item-preview"}/>
                                                </swiper-slide>
                                            )
                                        })}
                                    </swiper-container>
                                </div>
                            </Col>
                        </Row>
                    </Col>
                </Row>

                {/*Start Offcanvas*/}
                <Offcanvas
                    placement={"end"}
                    show={this.state.showModal}
                    onHide={() => {
                        this.setState({showModal: false});
                        this.resetNewCarouselItem();
                    }}>
                    <Offcanvas.Header closeButton>
                        <Offcanvas.Title>Agregar Página al Carrusel</Offcanvas.Title>
                    </Offcanvas.Header>
                    <Offcanvas.Body>
                        <Row>
                            <Col sm={12}>
                                <Form.Group className="mb-3" controlId="isStaticPage">
                                    <Form.Check
                                        type="switch"
                                        id="isStaticPage"
                                        label="Página estática"
                                        checked={page.isStaticPage}
                                        onChange={event => this.onChange(event)}/>
                                </Form.Group>
                            </Col>
                            <Col sm={12}>
                                <Form.Group className="mb-3" controlId="title">
                                    <Form.Label>Título</Form.Label>
                                    <Form.Control type="text"
                                                  placeholder="Título"
                                                  value={page.title}
                                                  onChange={event => this.onChange(event)}/>
                                </Form.Group>
                            </Col>
                            <Col sm={12}>
                                <Form.Group className="mb-3" controlId="subtitle">
                                    <Form.Label>Subtítulo</Form.Label>
                                    <Form.Control type="text"
                                                  placeholder="Subtítulo"
                                                  value={page.subtitle}
                                                  onChange={event => this.onChange(event)}/>
                                </Form.Group>
                            </Col>
                            <Col sm={12}>
                                <Form.Group className="mb-3" controlId="description">
                                    <Form.Label>Descripción</Form.Label>
                                    <Form.Control as="textarea" rows={3}
                                                  type="text"
                                                  placeholder="Descripción"
                                                  value={page.description}
                                                  onChange={event => this.onChange(event)}/>
                                </Form.Group>
                            </Col>
                            <Col sm={12}>
                                <Form.Group className="mb-3" controlId="goTo">
                                    <Form.Label>Enlace del CTA</Form.Label>
                                    <Form.Control type="text"
                                                  placeholder="Ejemplo: /products/sku"
                                                  value={page.goTo}
                                                  onChange={event => this.onChange(event)}/>
                                </Form.Group>
                            </Col>
                            <Col sm={12}>
                                <Form.Group className="mb-3" controlId="labelCTA">
                                    <Form.Label>Etiqueta del CTA</Form.Label>
                                    <Form.Control type="text"
                                                  placeholder="Ver productos"
                                                  value={page.labelCTA}
                                                  onChange={event => this.onChange(event)}/>
                                </Form.Group>
                            </Col>
                            <Col sm={12}>
                                <Form.Label>Imagen móvil</Form.Label>
                                <DragZone onImageDropped={this.onImageDropped}
                                          preSelectedImage={image}/>
                                <small className={'text-muted'}>La imagen debe ser rectangular. Al subir otra medida, la imagen será deformada.</small>
                            </Col>
                            <Col className={'mt-3 mb-3'} sm={12}>
                                <Form.Label>Imagen para web</Form.Label>
                                <DragZone onImageDropped={this.onImage2Dropped}
                                          preSelectedImage={imageMobile}/>
                                <small className={'text-muted'}>La imagen debe ser rectangular. Al subir otra medida, la imagen será deformada.</small>
                            </Col>
                            <Col className={'d-flex'}>
                                <Button disabled={this.state.isUploading}
                                        size={'sm'} className={'ml-auto'}
                                        onClick={() => this.onClickSaveCarouselItem()}>
                                    Agregar página
                                </Button>
                            </Col>
                        </Row>
                    </Offcanvas.Body>
                </Offcanvas>
            </Container>
        )
    }
}

export default withRouter(Carousel);
